module.exports = __webpack_public_path__ + "static/media/art-show.0f9a062c.png";